import { Type } from 'typebox';
export const AccountDeletionPayload = Type.Null();
export const AccountDeletionRequest = Type.Object({
    token: Type.String({ minLength: 1 })
});
export class HttpAccountResource {
    #httpClient;
    constructor(httpClient) {
        this.#httpClient = httpClient;
    }
    async requestDeletionVerificationEmail(options) {
        return await this.#httpClient.post({
            path: '/account/parent/request_deletion',
            payloadSchema: AccountDeletionPayload,
            signal: options?.signal
        });
    }
    async completeDeletion(request, options) {
        return await this.#httpClient.post({
            body: request,
            bodySchema: AccountDeletionRequest,
            path: '/account/parent/delete',
            payloadSchema: AccountDeletionPayload,
            signal: options?.signal
        });
    }
}
